/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';

import {
  SETTINGS_WIDGET_BODY_TEXT_LIGHT_STYLE,
  SETTINGS_WIDGET_BODY_TEXT_STYLE,
  SETTINGS_WIDGET_SECTION_INSET_STYLE,
  SETTINGS_WIDGET_SUBHEADING_STYLE,
} from './SettingsStyleLib';

type SettingsIntroProps = {
  title?: string;
  body?: string;
  bodyTone?: 'default' | 'mutedLight';
};

const INTRO_STYLE = css`
  label: INTRO_STYLE;
  ${SETTINGS_WIDGET_SECTION_INSET_STYLE}
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

const TITLE_STYLE = css`
  label: TITLE_STYLE;
  ${SETTINGS_WIDGET_SUBHEADING_STYLE}
`;

const BODY_STYLE = css`
  label: BODY_STYLE;
  ${SETTINGS_WIDGET_BODY_TEXT_LIGHT_STYLE}
`;

export const SettingsIntro = ({
  title = 'Exports',
  body = 'Select the content to include in exported artifact PDFs.',
  bodyTone = 'mutedLight',
}: SettingsIntroProps) => (
  <div css={INTRO_STYLE}>
    <div css={TITLE_STYLE}>{title}</div>
    <div
      css={[
        BODY_STYLE,
        bodyTone === 'default' && SETTINGS_WIDGET_BODY_TEXT_STYLE,
      ]}
    >
      {body}
    </div>
  </div>
);
